/* eslint-disable react/no-children-prop */
/* eslint-disable react/prop-types */
//disable linting due to some code belong to react markdown library
import { Typography } from '@mui/material';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import LoggingService from '../../Services/LoggingService';
import CustomLink from '../Link/CustomLink';
import CustomTypography, { LinkCallBacks } from './CustomTypography';
import './TypographyStyle.scss';

export const TypographyStyle = {
    aqua: 'aqua',
    red: 'red',
    orange: 'orange',
    teal: 'teal',
    link: 'link',
};

function mapStyleToCss(style: string): string {
    let cssStyle = '';
    Object.entries(TypographyStyle).forEach(([key, value]) => {
        if (key === style) {
            cssStyle = value;
        }
    });
    if (!cssStyle) {
        LoggingService.warn({
            componentName: Typography.name,
            args: ['Undefined style is found in translation file.'],
        });
    }
    return cssStyle;
}

export function createTypoFromStyle(
    text: string,
    linkCallBacks?: LinkCallBacks
): JSX.Element {
    function validURL(link: string | undefined) {
        if (link?.match(/tel:|mailto:/)) return true;
        const pattern = new RegExp(
            '^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$',
            'i'
        ); // fragment locator
        return link && !!pattern.test(link);
    }

    const renderTypograpgy = (
        <ReactMarkdown
            components={{
                p: ({ children, ...props }) => <div {...props}>{children}</div>,

                em: ({ children, ...props }) => (
                    <em {...props} style={{ fontSize: '0.9rem' }}>
                        {children}
                    </em>
                ),

                h3: ({ children, ...props }) => (
                    <div className={'customSubHeading'} {...props}>
                        {children}
                    </div>
                ),

                a: ({ href, title, children, ref: _ref, ...props }) => {
                    const handleClick = async () => {
                        const callBackName = href?.match(
                            /callback_[a-zA-Z0-9_-]*$/i
                        )
                            ? href.substring(href.indexOf('_') + 1)
                            : title?.match(/callback_[a-zA-Z0-9_-]*$/i)
                            ? title.substring(title.indexOf('_') + 1)
                            : '';

                        if (
                            linkCallBacks &&
                            Object.keys(linkCallBacks).includes(callBackName)
                        ) {
                            await linkCallBacks[callBackName]();
                        } else {
                            LoggingService.error({
                                componentName: CustomTypography.name,
                                args: [
                                    `Invalid callback with name: ${callBackName}`,
                                ],
                            });
                        }
                    };

                    return (
                        <CustomLink
                            href={validURL(href) ? href : undefined}
                            onClick={handleClick}
                            {...props}
                        >
                            {children}
                        </CustomLink>
                    );
                },

                code({ className, children, ...props }) {
                    const childText = String(children).trim();

                    // Handle inline style cases like: "className{content}"
                    if (childText.includes('{') && childText.includes('}')) {
                        const cssClass = childText
                            .substring(0, childText.indexOf('{'))
                            .trim();
                        const content = childText
                            .substring(
                                childText.indexOf('{') + 1,
                                childText.indexOf('}')
                            )
                            .trim();

                        return (
                            <span
                                className={mapStyleToCss(cssClass)}
                                {...props}
                            >
                                {content}
                            </span>
                        );
                    }

                    return (
                        <code className={className} {...props}>
                            {children}
                        </code>
                    );
                },
            }}
        >
            {text}
        </ReactMarkdown>
    );
    return <>{renderTypograpgy}</>;
}
